// Base
import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import AdminRoutes from './admin.js'
import SettingsRoute from './settings.js'

// Components
import Dashboard from '@/vue/Dashboard.vue'

import ConnectOverview from '@/vue/connect/ConnectOverview.vue'
import ConnectRecord from '@/vue/connect/ConnectRecord.vue'

import BoxesOverview from '@/vue/products/BoxesOverview.vue'
import BoxesRecord from '@/vue/products/BoxesRecord.vue'

import ProductsOverview from '@/vue/products/ProductsOverview.vue'
import ProductsRecord from '@/vue/products/ProductsRecord.vue'

// Contracten
import ContractsOverview from '@/vue/contracts/ContractsOverview.vue'
import ContractsRecord from '@/vue/contracts/ContractsRecord.vue'
import ContractsRecordView from '@/vue/contracts/ContractsRecordView.vue'
import ContractsTemplates from '@/vue/contracts/ContractsTemplates.vue'
import ContractsTemplateRecord from '@/vue/contracts/ContractsTemplateRecord.vue'

// Contracten > Prijswijzigingen
import ContractsPriceChanges from '@/vue/contracts/pricechanges/ContractsPriceChanges.vue'
import ContractsPriceChangesRecord from '@/vue/contracts/pricechanges/ContractsPriceChangesRecord.vue'

import InvoicesOverview from '@/vue/invoices/InvoicesOverview.vue'
import InvoicesRecord from '@/vue/invoices/InvoicesRecord.vue'
import CreditInvoiceOverview from '@/vue/creditinvoice/CreditInvoiceOverview.vue'
import CreateInvoiceRecord from '@/vue/creditinvoice/CreateInvoiceRecord.vue'

import EscalationRecord from '@/vue/invoices/EscalationRecord.vue'

import CustomersOverview from '@/vue/customers/CustomersOverview.vue'
import CustomersRecord from '@/vue/customers/CustomersRecord.vue'

import DiscountsOverview from '@/vue/discounts/DiscountsOverview.vue'
import DiscountsRecord from '@/vue/discounts/DiscountsRecord.vue'

import AccountsOverview from '@/vue/accounts/AccountsOverview.vue'

import PageNotFound from '@/vue/PageNotFound.vue'

Vue.use(VueRouter)


// TODO: Split me up in multiple route.js files (like admin & settings)

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return {
                ...savedPosition,
                behavior: 'smooth'
            }
        } else {
            return {
                x: 0,
                y: 0,
                behavior: 'smooth'
            }
        }
    },
    routes: [
        {
            path: '/panel',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                dateRangeFilter: true
            }
        },

        ...AdminRoutes,

        // Artikelen
        {path: '/panel/artikelen', redirect: to => { return '/panel/artikelen/boxen' }},
        {
            path: '/panel/artikelen/boxen',
            name: 'BoxesOverview',
            component: BoxesOverview,
            meta: {
                statusFilter: true
            }
        },
        {
            path: '/panel/artikelen/boxen/:id',
            name: 'BoxesRecord',
            component: BoxesRecord
        },
        {
            path: '/panel/artikelen/producten',
            name: 'ProductsOverview',
            component: ProductsOverview
        },
        {
            path: '/panel/artikelen/producten/:id',
            name: 'ProductsRecord',
            component: ProductsRecord
        },

        // Contracten
        {
            path: '/panel/contracten',
            name: 'ContractsOverview',
            component: ContractsOverview,
            meta: {
                dateRangeFilter: true,
                dateRangeFilterLabel: 'Startdatum bereik'
            }
        },
        {
            path: '/panel/contracten/nieuw',
            name: 'ContractsRecord',
            component: ContractsRecord
        },
        {
            path: '/panel/contracten/:id',
            name: 'ContractsRecordView',
            component: ContractsRecordView
        },
        {
            path: '/panel/contract-sjablonen',
            name: 'ContractsTemplates',
            component: ContractsTemplates
        },
        {
            path: '/panel/contract-sjablonen/:id',
            name: 'ContractsTemplateRecord',
            component: ContractsTemplateRecord
        },
        {
            path: '/panel/prijsveranderingen',
            name: 'ContractsPriceChanges',
            component: ContractsPriceChanges
        },
        {
            path: '/panel/prijsveranderingen/:id',
            name: 'ContractsPriceChangesRecord',
            component: ContractsPriceChangesRecord
        },



        // Facturen
        {
            path: '/panel/facturen/:type',
            name: 'InvoicesOverview',
            component: InvoicesOverview,
            meta: {
                dateRangeFilter: true,
                dateRangeFilterLabel: 'Factuurdatum bereik',
                hasInvoiceExportButton: true
            }
        },
        {
            path: '/panel/facturen/:type/:id',
            name: 'InvoicesRecord',
            component: InvoicesRecord
        },
        {
            path: '/panel/creditfacturen',
            name: 'CreditInvoiceOverview',
            component: CreditInvoiceOverview,
            meta: {
                dateRangeFilter: true,
                dateRangeFilterLabel: 'Factuurdatum bereik',
                hasInvoiceExportButton: true,
                type: 'credit'
            }
        },

        // Escalaties
        {
            path: '/panel/escalatie-dossiers/:id',
            name: 'EscalationRecord',
            component: EscalationRecord
        },

        // Create invoices
        {
            path: '/panel/creditfacturen/nieuw',
            name: 'CreditInvoiceRecord',
            component: CreateInvoiceRecord
        },
        {
            path: '/panel/losse-facturen/nieuw',
            name: 'CreateInvoiceRecord',
            component: CreateInvoiceRecord
        },


        // Users/accounts
        {
            path: '/panel/accounts',
            name: 'AccountsOverview',
            component: AccountsOverview
        },

        // Klanten/Customers
        {
            path: '/panel/klanten',
            name: 'CustomersOverview',
            component: CustomersOverview
        },
        {
            path: '/panel/klanten/:id',
            name: 'CustomersRecord',
            component: CustomersRecord
        },

        // Kortingen/Discounts
        {
            path: '/panel/kortingen',
            name: 'DiscountsOverview',
            component: DiscountsOverview
        },
        {
            path: '/panel/kortingen/:id',
            name: 'DiscountsRecord',
            component: DiscountsRecord
        },

        // Access/PlanitEasy connect
        {
            path: '/panel/connect',
            name: 'ConnectOverview',
            component: ConnectOverview,
            meta: {
                dateRangeFilter: true,
                dateRangeFilterLabel: 'Toegang verleend tussen',
                activeSwitch: true
            }
        },
        {
            path: '/panel/connect/:id',
            name: 'ConnectRecord',
            component: ConnectRecord
        },

        // Instellingen
        ...SettingsRoute,


        // Fallback
        {
            path: '*',
            name: '404',
            component: PageNotFound
        }
    ]
})

// Fix NavigationDuplicated error
// This error occurs when navigating to the same route
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }

        // Return a resolved promise to suppress the error
        return Promise.resolve()
    })
}

export default router